module.exports = __webpack_public_path__ + "static/media/aurus.ad1a7a1a.jpg";